import { useCallback, useEffect, useState } from 'react'
import { Modal, Table } from 'react-bootstrap'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import WmsAddressService from '../../../../services/database/WmsAddressService'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import { Container } from './styles'

export function ModalViewProducts({ isOpen, onClose, codendereco }) {
  const [info, setInfo] = useState({}) //! { addresses: [], quantity: number }

  const [isProductsLoading, setIsProductsLoading] = useState(true)

  const getProductsOnAddress = useCallback(async () => {
    try {
      setIsProductsLoading(true)

      const data = await WmsAddressService.getProductsOnAddress(codendereco)

      setInfo(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível listar os produtos!')
    } finally {
      setIsProductsLoading(false)
    }
  }, [codendereco])

  useEffect(() => {
    getProductsOnAddress()
  }, [getProductsOnAddress])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modalzpl"
      centered
    >
      <Container>
        {isProductsLoading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 5,
            }}
          >
            <CustomSpinner size={25} />

            <p
              style={{
                all: 'unset',
              }}
            >
              Carregando produtos...
            </p>
          </div>
        ) : (
          <>
            {info?.addresses?.length > 0 ? (
              <>
                <h5>
                  Este endereço contém{' '}
                  <strong>
                    {info?.quantity} {info?.quantity > 1 ? 'itens' : 'item'}
                  </strong>
                  :
                </h5>

                <Table>
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Descrição</th>
                      <th>QT</th>
                    </tr>
                  </thead>

                  <tbody>
                    {info?.addresses?.map((product) => (
                      <tr key={product.sku}>
                        <td>{product.sku}</td>
                        <td>{product.descricao}</td>
                        <td>{product.qt}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            ) : (
              <h1>Sem produtos!</h1>
            )}
          </>
        )}
      </Container>
    </Modal>
  )
}
